import React from 'react';
import { BridgeForm } from './BridgeForm';
import { TransactionHistory } from './TransactionHistory';
import { FaucetSection } from '../faucet/FaucetSection';
import { useBridge } from '../../hooks/useBridge';
import { useWallet } from '../../hooks/useWallet';
import { useSNS } from '../../hooks/useSNS';
import { LOCAL_STORAGE_KEY } from '../../utils/constants';

export const BridgePage: React.FC = () => {
  const { walletInfo } = useWallet();
  const { snsName } = useSNS(walletInfo.address);
  const { 
    transactions, 
    clearTransactions,
    transactionState,
  } = useBridge(walletInfo.address);

  const handleRefreshTransactions = () => {
    if (walletInfo.address) {
      try {
        const storedTransactions = localStorage.getItem(`${LOCAL_STORAGE_KEY}-${walletInfo.address}`);
        if (storedTransactions) {
          window.location.reload();
        }
      } catch (error) {
        console.error('Error loading transactions from local storage:', error);
      }
    }
  };

  return (
    <div className="relative max-w-4xl mx-auto z-10">
      <div className="grid grid-cols-1 gap-6 sm:gap-8 relative z-10">
        <div>
          {/* Welcome message with SNS */}
          {walletInfo.isConnected && snsName && (
            <p className="text-sm text-gray-400 mb-1">
              Welcome back, <span className="text-primary-400 font-medium">{snsName}</span> 👋
            </p>
          )}
          <h1 className="text-2xl sm:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary-400 to-secondary-500 mb-2">Shido Native Bridge</h1>
          <p className="text-sm sm:text-base text-gray-400 mb-4 sm:mb-6">
            Transfer native SHIDO between Shido and Ethereum
          </p>
            
            <BridgeForm />
          </div>
          
          {/* Transaction History */}
          <TransactionHistory 
            transactions={transactions} 
            onClearHistory={clearTransactions}
            onRefresh={handleRefreshTransactions}
          />
          
        {/* Faucet Section - At the bottom, slim banner */}
        <FaucetSection />
      </div>
    </div>
  );
};
